import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'
// import reportWebVitals from './reportWebVitals'
import { Auth0ProviderWithNavigate } from './components/Auth/Auth0ProviderWithNavigate'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SnackbarProvider } from 'notistack'
import { Provider } from 'react-redux'
import { store } from './redux/store'

import './scss/index.scss'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import theme from './theme/theme'
import ErrorBoundary from './components/ErrorBoundaries/ErrorBoundary'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { LicenseInfo } from '@mui/x-license'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_KEY || '')

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnReconnect: false, // disables it for all queries
        },
    },
})

root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Provider store={store}>
                <QueryClientProvider client={queryClient}>
                    <SnackbarProvider
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        autoHideDuration={2000}
                    >
                        <Router>
                            <Auth0ProviderWithNavigate>
                                <ErrorBoundary>
                                    <App />
                                </ErrorBoundary>
                            </Auth0ProviderWithNavigate>
                        </Router>
                    </SnackbarProvider>
                    <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
            </Provider>
        </ThemeProvider>
    </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
